import { compose } from 'redux'
import { withHandlers, withState } from 'recompose'
import { rest } from 'services'

const getAddresses = ({ data: { predictions: results }}) =>
  results.map(({ description: place, place_id: id }) => ({
    place,
    id
  }))

const withAddresses = withState('addresses', 'setAddresses', [])

const withFetchAddresses = withHandlers({
  fetchAddresses: ({ setAddresses }) => query => rest.api
    .getGooglePlaceSuggestions(query)
    .then(result => setAddresses(getAddresses(result)))
})

const withResetAddresses = withHandlers({
  resetAddresses: ({ setAddresses }) => () => setAddresses([])
})

export default compose(
  withAddresses,
  withFetchAddresses,
  withResetAddresses
)
